function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      position: absolute;\n      top: ",
        "px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  box-sizing: border-box;\n  align-items: center;\n  background-color: ",
        ";\n  bottom: 0;\n  display: flex;\n  flex-direction: row;\n  height: 61px;\n  left: 0;\n  justify-content: flex-start;\n  opacity: ",
        ";\n  padding: 15px;\n  position: fixed;\n  right: 0;\n  top: -61px;\n  transform: ",
        ";\n  transition: 0.2s transform, 0.2s opacity;\n  z-index: 9999;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.3);\n  border-radius: 3px;\n  display: flex;\n  height: 32px;\n  justify-content: center;\n  margin-right: 15px;\n  width: 32px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: #fff;\n  font-size: 14px;\n  a {\n    text-decoration: underline;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  align-items: center;\n  align-self: center;\n  background: none;\n  border: none;\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin-left: auto;\n  padding: 4px;\n\n  &:focus-visible {\n    border-radius: 3px;\n    outline: 2px solid #fff;\n    outline-offset: 2px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import styled, { css } from 'styled-components';
var backgroundColorMapping = {
    danger: '#da5347',
    error: '#da5347',
    info: '#1b9edb',
    success: '#75ba50'
};
export var Container = styled.div(_templateObject1(), function(props) {
    return _.get(backgroundColorMapping, props.type, backgroundColorMapping.danger);
}, function(props) {
    return props.visible ? 1 : 0;
}, function(props) {
    return props.visible ? 'translate3d(0, 61px, 0)' : 'translate3d(0, 0, 0)';
}, function(param) {
    var isIframe = param.isIframe, iframeOffset = param.iframeOffset, parentOffset = param.parentOffset;
    return isIframe && css(_templateObject(), parentOffset + iframeOffset - 61);
});
export var IconContainer = styled.div(_templateObject2());
export var Message = styled.span(_templateObject3());
// margin-left: auto pins the button to the far right of the flex row without changing the
// icon/message layout; flex-shrink: 0 keeps it from collapsing under long messages.
export var DismissButton = styled.button(_templateObject4());
// font-awesome "times"
export function DismissIcon() {
    return /*#__PURE__*/ _jsx("svg", {
        "aria-hidden": "true",
        focusable: "false",
        height: "14",
        viewBox: "0 0 1792 1792",
        width: "14",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z",
            fill: "currentColor"
        })
    });
}
export default {
    Container: Container,
    IconContainer: IconContainer,
    Message: Message,
    DismissButton: DismissButton,
    DismissIcon: DismissIcon
};
